// extracted by mini-css-extract-plugin
module.exports = {"row":"styles-module__row___ArCBg","col":"styles-module__col___wjTv1","message":"styles-module__message___gS507"};